<template>
  <v-container fluid>
    <Title v-if="$vuetify.breakpoint.smAndUp" :src="'deals'" :text="'Deals'" />
    <div v-if="promotions">
      <div v-for="promotion in promotions" :key="promotion.department_id">
        <v-row
          align="center"
          class="background-color-white mr-sm-0"
          justify="space-between"
        >
          <v-col class="px-6">
            <div class="font-size-lg ml-1">{{ getDepartmentDisplayName(promotion.department_id)}}</div>
          </v-col>
          <v-col class="text-right px-6">
            <router-link
              :to="`/deals/${promotion.department_id}`"
              class="align-center d-flex justify-end"
            >
              <div>View more Deals</div>
              <v-icon color="primary">mdi-chevron-right</v-icon>
            </router-link>
          </v-col>
        </v-row>
        <v-row class="background-color-white mb-6 mr-sm-0 px-6">
          <v-col
            v-for="product in adjustProductsLengthForBreakpoint(
              promotion.products
            )"
            :key="product.upc"
            class="position-relative px-6"
            cols="6"
            md="3"
            xl="2"
          >
            <Product :product="product" :size="'md'" />
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapState , mapGetters} from "vuex";
import Product from "@/components/Product/index.vue";
import Title from "@/components/UI/Title.vue";

export default {
  name: "Promotions",
  components: { Product, Title },
  computed: {
        ...mapGetters("departments", {
      getDepartmentDisplayName: 'getDepartmentDisplayName'
    }),
    ...mapState({
      promotions: (state) => state.promotions.data,
    }),
  },
  methods: {
    adjustProductsLengthForBreakpoint(products) {
      // 4 products are returned from API which fills an xl row (default)
      const end = {
        xs: 1,
        sm: 2,
        md: 4,
        lg: 4,
        xl: 6,
      };
      return products.slice(0, end[this.$vuetify.breakpoint.name]) || products;
    },
  },
};
</script>
